import React from 'react'
import styled from 'styled-components'

const Playlist = styled.div`
  display: flex;
  margin-bottom: 1rem;
  cursor: pointer;
`

const ImageWrapper = styled.div`
  width: 80px;
  height: 80px;
  margin-right: .5rem;
  border-radius: 4px;
  overflow: hidden;
`

const PlaylistInfo = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;

  span {
    position: absolute;
    top: 0;
    left: 0;
    color: #0019F8;
    font-size: 14p;
  }
`

const renderImage = (collection) => {
  if (collection.presentation) {
    if (collection.presentation.image && collection.presentation.image.mediumSquare) {
      return (<ImageWrapper>
        <img
          height="80"
          width="80"
          src={collection.presentation.image.mediumSquare.url}
          alt={collection.name}
        />
      </ImageWrapper>)
    }
    return (<ImageWrapper>
      <div
        style={{
          backgroundColor: '#0019F8',
          height: "80px",
          width: "80px"
        }}
      />
    </ImageWrapper>)
  }
  return (<ImageWrapper>
    <div
      style={{
        backgroundColor: collection.colors.length ? collection.colors[0] : '#0019F8',
        height: "80px",
        width: "80px"
      }}
    />
  </ImageWrapper>)
}

export default (props) => {
  return (
    props.collections.length ? (
      <ul>
        {props.collections.map((collection, i) => (
          <li key={i}>
            <Playlist onClick={() => props.changeCollection(collection.id)}>
              {renderImage(collection)}
              <PlaylistInfo>
                <h2 className="book" style={{ fontSize: '20px' }}>{collection.name}</h2>
                {props.currentPlayFrom && props.currentPlayFrom.playFrom.name === collection.name && (
                  <span>Now Playing</span>
                )}
              </PlaylistInfo>
            </Playlist>
          </li>
        ))}
      </ul>
    )
      :
      (<div style={{ textAlign: 'center', margin: '1rem 0' }}>You haven't added any {props.name} yet</div>)
  )
}



// WEBPACK FOOTER //
// ./src/Views/ChangeMusic/MusicList.js